import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BrakeTypeOptionsNoNA } from '../../options'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const MachineRoomLayout: FormLayoutPage = {
  key: 'machine-room',
  title: 'Machine Room',
  contents: [
    layoutFields.speed,
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.usage,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.typeOfUse,
    layoutFields.drivingMachineInstallYear,
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasCounterweightSafeties,
    layoutFields.hasMGSet,
    layoutFields.governorType,
    layoutFields.acopumdType,
    layoutFields.driveType,
    { ...layoutFields.brakeType, options: BrakeTypeOptionsNoNA },
    layoutFields.hasNonMetallicSheaveLiner,
    layoutFields.hasCoatedRopes,
    layoutFields.hasTractionLossDetection,
    layoutFields.hasBrokenSuspensionDetection,
    layoutFields.hasEmergencyPower,
    layoutFields.isMachineRoomLess,
    layoutFields.execSoftwareRevision,
    layoutFields.controllerManufacturerAndModel,
    layoutFields.drivingMachineManufacturerAndModel,
    layoutFields.carsShareMachineRoom,
  ],
}

const CarTopLayout: FormLayoutPage = {
  key: 'car-top',
  title: 'Car Top',
  contents: [
    layoutFields.suspensionMembersInstallYear,
    layoutFields.interlocksInstallYear,
    layoutFields.typeOfDoorOperator,
    layoutFields.doorRestrictorType,
    layoutFields.suspensionMeansType,
    layoutFields.hasSeismicDevices,
    layoutFields.hasBrokenRopeSelectorSwitch,
    layoutFields.guideType,
    layoutFields.doorOperatorManufacturerAndModel,
  ],
}

const InCarLayout: FormLayoutPage = {
  key: 'in-car',
  title: 'In Car',
  contents: [
    layoutFields.hoistwayDoorType,
    layoutFields.carDoorType,
    layoutFields.numLandings,
    layoutFields.numberOfOpenings,
    layoutFields.doorOpeningMethod,
    layoutFields.doorPanelsType,
    layoutFields.hasHoistwayAccess,
    layoutFields.hasFirefighterService,
    layoutFields.isObservationElevator,
    layoutFields.hasVisionPanels,
  ],
}

const PitLayout: FormLayoutPage = {
  key: 'pit',
  title: 'Pit',
  contents: [
    layoutFields.bufferType,
    layoutFields.hasBufferSwitches,
    layoutFields.hasCompensation,
    layoutFields.hasCompensationSheave,
    layoutFields.numCarsSharePit,
  ],
}

export const ElectricElevatorFormLayout: FormLayout =
  buildLayoutWithCommonSections([
    BasicInfoLayout,
    MachineRoomLayout,
    CarTopLayout,
    InCarLayout,
    PitLayout,
    NotesLayout,
  ])
